import React, { useState } from 'react';
import { 
  CurrencyDollarIcon, 
  WalletIcon, 
  ChartBarIcon,
  CogIcon
} from '@heroicons/react/24/outline';
import BudgetDashboard from './BudgetDashboard';
import WalletManagement from './WalletManagement';
import UsageAnalytics from './UsageAnalytics';
import BuildCoinsSettings from './BuildCoinsSettings';

const BuildCoinsDashboard = () => {
  const [activeTab, setActiveTab] = useState('budgets');

  const tabs = [
    {
      id: 'budgets',
      name: 'Budget Management',
      icon: CurrencyDollarIcon,
      component: BudgetDashboard
    },
    {
      id: 'wallets',
      name: 'Wallet Management',
      icon: WalletIcon,
      component: WalletManagement
    },
    {
      id: 'analytics',
      name: 'Usage Analytics',
      icon: ChartBarIcon,
      component: UsageAnalytics
    },
    {
      id: 'settings',
      name: 'Settings',
      icon: CogIcon,
      component: BuildCoinsSettings
    }
  ];

  const ActiveComponent = tabs.find(tab => tab.id === activeTab)?.component;

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Navigation Tabs */}
      <div className="bg-white shadow">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex space-x-8">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`flex items-center px-1 py-4 border-b-2 font-medium text-sm ${
                    activeTab === tab.id
                      ? 'border-blue-500 text-blue-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
                >
                  <Icon className="w-5 h-5 mr-2" />
                  {tab.name}
                </button>
              );
            })}
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto">
        {ActiveComponent && <ActiveComponent />}
      </div>
    </div>
  );
};

export default BuildCoinsDashboard;
